import { Theme, useMediaQuery } from '@mui/material';

/**
 * Just a simple wrapper with typed Theme.
 * Usefull, if you need to use theme, but
 * don't want to call useTheme all the time.
 */
export const useTypedMediaQuery = useMediaQuery<Theme>;
